import React from "react";
import clsx from "clsx";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    return (
      <input
        ref={ref}
        {...props}
        className={clsx(
          "border border-gray-300 rounded-md p-2 w-full",
          props.className
        )}
      />
    );
  }
);

Input.displayName = "Input";
